export default "__VITE_ASSET__986130b2__"